import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import "@/App.css";
import { setLenis } from "@/lib/scroll";
import { ProductsProvider } from "@/lib/products";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { BestSellers } from "@/components/BestSellers";
import { DanielKlein } from "@/components/DanielKlein";
import { PriceCollections } from "@/components/PriceCollections";
import { CategoryNav } from "@/components/CategoryNav";
import { SelectedProducts } from "@/components/SelectedProducts";
import { Manifesto } from "@/components/Manifesto";
import { TeknikServis } from "@/components/TeknikServis";
import { InstagramGrid } from "@/components/InstagramGrid";
import { WhatsAppConcierge, FloatingWhatsApp } from "@/components/WhatsAppConcierge";
import { Footer } from "@/components/Footer";
import { QuickViewProvider } from "@/components/QuickView";
import TeknikServisPage from "@/pages/TeknikServisPage";
import HikayemizPage from "@/pages/HikayemizPage";

const Home = () => {
  const [category, setCategory] = useState("all");
  const [priceFilter, setPriceFilter] = useState(null);

  return (
    <main>
      <Helmet>
        <title>Atılmaz Saat — Zamana Değer Katar | Kol Saati, Takı, Gözlük</title>
        <meta
          name="description"
          content="2006'dan beri Balıkesir Burda AVM'de kol saati, takı ve gözlükte güvenilir adres. Orijinallik garantisi ve uzman teknik servis. Atılmaz Saat — Zamana Değer Katar."
        />
      </Helmet>
      <Hero />
      <Marquee />
      <BestSellers />
      <DanielKlein />
      <PriceCollections onSelectPrice={setPriceFilter} />
      <CategoryNav onSelectCategory={setCategory} />
      <TeknikServis />
      <SelectedProducts
        category={category}
        onCategoryChange={setCategory}
        priceFilter={priceFilter}
        onClearPrice={() => setPriceFilter(null)}
      />
      <Manifesto />
      <InstagramGrid />
      <WhatsAppConcierge />
    </main>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, duration: 1.2 });
    setLenis(lenis);
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <HelmetProvider>
      <ProductsProvider>
        <QuickViewProvider>
          <div className="App bg-ivory min-h-screen">
            <BrowserRouter>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/teknik-servis" element={<TeknikServisPage />} />
                <Route path="/hikayemiz" element={<HikayemizPage />} />
              </Routes>
              <Footer />
              <FloatingWhatsApp />
            </BrowserRouter>
          </div>
        </QuickViewProvider>
      </ProductsProvider>
    </HelmetProvider>
  );
}

export default App;
